import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

export default function Icon({ src, className, alt = '', width, height, style, margin, ...props }) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn(styles.img_icon, className)}
      style={{
        width,
        height,
        margin,
        ...style,
      }}
      {...props}
    />
  );
}
